settingsMenuButton = {};

settingsMenuButton.create = function () {
  var button = new PIXI.Container();

  this._sideMenuOpen = false;

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button.canEnable = function () {
    return this._flags.platformEnabled && this._sideMenuOpen;
  };

  button.canShow = function () {
    return this._flags.platformVisible;
  };

  button.onPressedCallback = function () {
    soundManager.play("buttonPressed");

    messageBus.postImmediate("ui:modal", { reason: "Settings open" });
  };

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.onConfig = function (config) {
    button._flags.platformEnabled = config.data.uiElements.btnSettings.enabled;
    button._flags.platformVisible = config.data.uiElements.btnSettings.visible;
  };

  button.sideMenuOpenMsg = function () {
    this._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    this._sideMenuOpen = false;
  };

  messageBus.subscribe(
    "game:sideMenuOpen",
    button.sideMenuOpenMsg.bind(button)
  );
  messageBus.subscribe(
    "game:sideMenuClosed",
    button.sideMenuClosedMsg.bind(button)
  );
  messageBus.subscribe("spinner:GameConfigEvent", button.onConfig);

  return button;
};

settingsMenuButton.initialise = function (json, object) {};
settingsMenuButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "settingsMenuButton",
  settingsMenuButton.create,
  settingsMenuButton.initialise,
  settingsMenuButton.getFilesRequired
);
